import React from 'react'
import queryString from 'query-string'
import { getDatesFromOffset } from '../../utils'
import { CardType, useOdsWatchedVehiclesCountQuery } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { BasicWidgetProps } from '../../types'

const WatchedVehicles = ({
    config: { text = 'Vehicles', text2 = 'Watched', secondaryText = 'in the last 7 days', offset },
    handleConfig,
    widgetId,
    readonly,
}: BasicWidgetProps): React.ReactElement => {
    const { startDate, endDate } = getDatesFromOffset(offset, {
        start: -6,
        end: 0,
    })

    const { data, loading } = useOdsWatchedVehiclesCountQuery({
        variables: { startDate, endDate },
    })

    const watched = data?.auction?.card?.watchedVehiclesCount
    const number = typeof watched === 'number' ? watched : ''

    return (
        <SingleNumberWidget
            cardType={CardType.PIPELINE}
            action={{
                text: 'View Vehicles',
                link: `/watchedvehicles?${queryString.stringify({
                    startDate,
                    endDate,
                })}`,
            }}
            number={number}
            text={text}
            text2={text2}
            secondaryText={secondaryText}
            loading={loading}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default WatchedVehicles
